import React, {Component} from 'react';
import FeedbackButton from './Button';
import {FeedbackWrapper} from './styles';

class Feedback extends Component {
  render() {
    const {stepId, stepIndex, isMobile} = this.props;

    return (
      <FeedbackWrapper>
        <FeedbackButton stepId={stepId} stepIndex={stepIndex} isMobile={isMobile} />
      </FeedbackWrapper>
    );
  }
}

export default Feedback;
